import {AsyncThunk} from '@reduxjs/toolkit';
import ApiService from 'redux/services/api-service';

type APIInventory = any; // typeof import('../../../../backend/inventory/inventory-reports/api');
type APIDataProcessing = any; // typeof import('../../../../backend/inventory/data-processing/api');
type ProxyInvoke<T> = 0 extends 1 & T
  ? Record<string, (...a: any) => any>
  : {
      [K in keyof T]: (
        payload: T[K] extends (p: infer P) => any ? P : never,
      ) => Promise<T[K] extends (a: any) => infer V ? Awaited<V> : never>;
    };
export type ForSuccess<F> = F extends AsyncThunk<infer R, any, any> ? R : never;
export type ResourceState = 'start' | 'loading' | 'error' | 'success';

export const proxyFetchNodeInventory = new Proxy(
  {},
  {
    get: (_, path: string) => async payload =>
      (await ApiService.post(`/inventory/inventory-reports/api/${path}`, payload)).data,
  },
) as ProxyInvoke<APIInventory>;
export const proxyFetchNodeDataProcessing = new Proxy(
  {},
  {
    get: (_, path: string) => async payload =>
      (await ApiService.post(`/inventory/data-processing/api/${path}`, payload)).data,
  },
) as ProxyInvoke<APIDataProcessing>;

type ScopedSelector<T extends unknown, U extends {}> = (
  props: T,
) => <V extends (data: U) => unknown>(callback: V) => ReturnType<V>;
export type UseTypedSelector<
  A extends any[],
  D extends [{}, {}] = [{}, {}],
  V extends ScopedSelector<any, any> = ScopedSelector<{}, {}>,
> = A extends [infer F, ...infer R]
  ? F extends [any, any]
    ? UseTypedSelector<R, [D[0] & F[0], D[1] & F[1]], ScopedSelector<D[0] & F[0], D[1] & F[1]> & V>
    : [A, D, V]
  : [A, D, V];
